const airportList = [
    'BOS',
    'CLT',
    'CUN',
    'DEN',
    'EWR',
    'JFK',
    'LAS',
    'LAX',
    'MCO',
    'MIA',
    'MSY',
    'PHL',
    'PHX',
    'SAN',
    'SEA',
    'SFO',
    'TPA'
];

const locale = 'en-us';

const parsedDataObjects = airportList.map(locationId => {
    /* eslint-disable global-require */
    const content = require(`./${locale}/${locationId}-content.json`);
    const factoids = require(`./${locale}/${locationId}-factoid.json`);
    const images = require(`./${locale}/${locationId}-images.json`);
    /* eslint-enable global-require */

    return {
        [`${locationId}content`]: content,
        [`${locationId}factoids`]: factoids,
        [`${locationId}images`]: images,
    };
});

const mergedDataObjects = parsedDataObjects.reduce(
    (previousValue, currentValue) => Object.assign({}, previousValue, currentValue),
    {},
);

const content = {
    [locale]: mergedDataObjects,
};

const getContent = () => content;

export default getContent;
